import {IChannelIcon, IPackageChannelIcon} from "./api/apiFunctions";

export class Util {
    public static getPackageImageUrl(channelIcons: IPackageChannelIcon[]) {
        if (!channelIcons || channelIcons.length < 1) {
            return "";
        }

        const packageIconPriority = ["XSITE_HIGH_RESOLUTION_LOGO", "PNG_PRINT"];
        for (let iconType of packageIconPriority) {
            const icon = (channelIcons || []).find(x => x.name === iconType);
            if (icon) {
                return icon.iconUrl;
            }
        }
        return channelIcons[0].iconUrl;
    }

    public static getImageUrl(channelIcons: IChannelIcon[]) {
        if (!channelIcons || channelIcons.length < 1) {
            return "";
        }

        const channelIconPriority = ["PNG_80_80", "PNG_64_43", "LOGO_ON_FRAME", "XSITE_LOGO", "XSITE_HIGH_RESOLUTION_LOGO", "PNG_PRINT"];

        for (let iconType of channelIconPriority) {
            const icon = (channelIcons || []).find(x => x.name === iconType);
            if (icon) {
                return `https://content.altibox.no/nuxeo/nxfile/${icon.url}`;
            }
        }

        return `https://content.altibox.no/nuxeo/nxfile/${channelIcons[0].url}`;
    }
}

